const LOGIN = "LOGIN";
const LOGOUT = "LOGOUT";
const USERROLEACCOUNT = "USERROLEACCOUNT"
const TEACHERSCHOOLLIST = "TEACHERSCHOOLLIST"
const ADD_STUDENT_LISTING = "ADD_STUDENT_LISTING";


export { LOGIN, LOGOUT, USERROLEACCOUNT ,TEACHERSCHOOLLIST, ADD_STUDENT_LISTING };